export enum ActionButtonIntent {
  Primary = "primary",
  Secondary = "secondary",
  Outlined = "outlined",
  Danger = "danger",
  /** To be used only if the button opens a menu, like in NavBar */
  Active = "active",
}

export enum ActionButtonSize {
  Normal = "normal",
  Small = "small",
  InTableCell = "tiny",
}

export enum ActionButtonIconPlacement {
  Right = "right",
  Left = "left",
}
